import { useTheme } from 'styled-components';
import useClientRegisterPageController from '../../1_application/client/clientRegisterPageController';
import BoxContainer from '../core/components/box/boxContainer';
import Column from '../core/components/box/column';
import Row from '../core/components/box/row';
import SizedBox from '../core/components/box/sizedBox';
import LXMiddleButton from '../core/components/buttons/lxMiddleButton';
import { XCenter } from '../core/components/center';
import LXStep from '../core/components/step/lxStep';
import { LXbody, LXh2, LXh4 } from '../core/texts/lxText';
import ClientForm from './components/clientForm';
import ClientInfoView from './components/clientInfoView';

const ClientRegisterPage: React.FC = () => {
  const theme = useTheme();
  const c = useClientRegisterPageController();

  return (
    <XCenter>
      <Column>
        <SizedBox height={80}></SizedBox>
        <LXh2>{theme.texts.newClient}</LXh2>
        <SizedBox height={40}></SizedBox>
        <LXStep
          width={284}
          current={c.step}
          titles={[theme.texts.clientInformation, theme.texts.confirm]}
        ></LXStep>
        <SizedBox height={30}></SizedBox>
        {c.step === 0 && (
          <BoxContainer>
            <Column alignItems="center">
              <Row
                width="100%"
                justifyContent="space-between"
                alignItems="center"
              >
                <Column>
                  <LXh4>{theme.texts.enterClientInformation}</LXh4>
                  <SizedBox height={4}></SizedBox>
                  <LXbody color={theme.colors.caption}>
                    {theme.texts.pleaseEnterTheRequiredInformation}
                  </LXbody>
                </Column>
                <LXMiddleButton disabled={c.canNext} onClick={c.toNext}>
                  {theme.texts.next}
                </LXMiddleButton>
              </Row>
              <SizedBox height={40}></SizedBox>
              <XCenter>
                <Column>
                  <ClientForm
                    client={c.client.current}
                    onClientChange={c.setClient}
                    onClientValid={c.setIsClientValid}
                  ></ClientForm>
                </Column>
              </XCenter>
            </Column>
          </BoxContainer>
        )}
        {c.step === 1 && c.client.current && (
          <BoxContainer>
            <Column>
              <Row
                width="100%"
                justifyContent="space-between"
                alignItems="center"
              >
                <Column>
                  <LXh4>{theme.texts.confirm}</LXh4>
                  <SizedBox height={4}></SizedBox>
                  <LXbody color={theme.colors.caption}>
                    {theme.texts.pleaseCheckTheInformationYouEntered}
                  </LXbody>
                </Column>
                <Row>
                  <LXMiddleButton kind={'secondary'} onClick={c.toPrev}>
                    {theme.texts.prev}
                  </LXMiddleButton>
                  <SizedBox width={8}></SizedBox>
                  <LXMiddleButton onClick={c.onSaveHandler}>
                    {theme.texts.save}
                  </LXMiddleButton>
                </Row>
              </Row>
              <SizedBox height={40}></SizedBox>
              <ClientInfoView client={c.client.current}></ClientInfoView>
            </Column>
          </BoxContainer>
        )}
      </Column>
    </XCenter>
  );
};

export default ClientRegisterPage;
